function saveRecentSearches(type, item) {
  const MAX_ITEMS = 10;
  const STORAGE_KEY = 'recentSearches';

  if (!item?.searchText || !item?.url) {
    console.warn('Invalid item passed to saveRecentSearches:', item);
    return;
  }

  let recentSearches = {
    combinedSearches: [],
    drugSearches: [],
  };

  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored) {
      recentSearches = JSON.parse(stored);
    }
  } catch (e) {
    console.error('Failed to parse recentSearches:', e);
  }

  const keyMap = {
    drugSearch: 'drugSearches',
    combinedSearch: 'combinedSearches',
  };

  const key = keyMap[type];
  if (!key) return recentSearches;

  const stripTags = (str) => str.replace(/<[^>]*>/g, '');
  const newText = stripTags(item.searchText);

  const existingList = Array.isArray(recentSearches[key])
    ? recentSearches[key]
    : [];

  const updatedList = existingList.filter(
    (entry) => stripTags(entry?.searchText) !== newText
  );

  updatedList.unshift({
    searchText: item.searchText,
    url: item.url,
    title: item.title
  });

  recentSearches[key] = updatedList.slice(0, MAX_ITEMS);
  
  localStorage.setItem(STORAGE_KEY, JSON.stringify(recentSearches));

  return recentSearches;
}

function clearDrugSearch() {
  const recentSearches = localStorage.getItem('recentSearches');
  const recentSearch = JSON.parse(recentSearches) || {};
  recentSearch.drugSearches = [];
  localStorage.setItem('recentSearches', JSON.stringify(recentSearch));
  return recentSearch;
}

function getRecentSearches() {
  const recentSearches = localStorage.getItem('recentSearches');
  return JSON.parse(recentSearches);
}

export { getRecentSearches, saveRecentSearches, clearDrugSearch };
